/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ChangeRequestStatusDto } from './changeRequestStatusDto.schema';

export const IReadOnlyListOfChangeRequestStatusDto = zod.array(zod.lazy(() => ChangeRequestStatusDto));

export type IReadOnlyListOfChangeRequestStatusDto = zod.input<typeof IReadOnlyListOfChangeRequestStatusDto>;
export type IReadOnlyListOfChangeRequestStatusDtoOutput = zod.output<typeof IReadOnlyListOfChangeRequestStatusDto>;
